import {
  RuleType,
  RuleTypeFilter,
} from 'src/pages/GlobalSetting/CorrelatedRuleTemplates/types';

export const rulesListLinks = {
  [RuleType.UserDefined]: `/policy/global-settings/correlated-rule-list?ruleType=${RuleTypeFilter.UserDefined}`,
  [RuleType.PreDefined]: `/policy/global-settings/correlated-rule-list?ruleType=${RuleTypeFilter.PreDefined}`,
};
